import { defineMessages } from 'react-intl';

export default defineMessages({
  open: {
    id: 'devicestatus.open.title',
    defaultMessage: 'Open'
  },
  closed: {
    id: 'devicestatus.closed.title',
    defaultMessage: 'Closed'
  },
  suspended: {
    id: 'devicestatus.suspended.title',
    defaultMessage: 'Suspended'
  }
});
